// src/geo.ts
function calculateDistance(from, to) {
  const R = 6371e3;
  const \u03C61 = from.lat * Math.PI / 180;
  const \u03C62 = to.lat * Math.PI / 180;
  const \u0394\u03C6 = (to.lat - from.lat) * Math.PI / 180;
  const \u0394\u03BB = (to.lng - from.lng) * Math.PI / 180;
  const a = Math.sin(\u0394\u03C6 / 2) * Math.sin(\u0394\u03C6 / 2) + Math.cos(\u03C61) * Math.cos(\u03C62) * Math.sin(\u0394\u03BB / 2) * Math.sin(\u0394\u03BB / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}
function formatDistance(meters) {
  if (meters >= 1e3) {
    return `${(meters / 1e3).toFixed(1)} km`;
  }
  return `${Math.round(meters)} m`;
}
function calculateRouteDistance(points) {
  if (points.length < 2) return 0;
  let total = 0;
  for (let i = 0; i < points.length - 1; i++) {
    total += calculateDistance(points[i], points[i + 1]);
  }
  return total;
}
function geohash(lat, lng, precision = 8) {
  const base32 = "0123456789bcdefghjkmnpqrstuvwxyz";
  let hash = "";
  let bits = 0;
  let bitsTotal = 0;
  let hashValue = 0;
  let maxLat = 90;
  let minLat = -90;
  let maxLng = 180;
  let minLng = -180;
  while (hash.length < precision) {
    if (bitsTotal % 2 === 0) {
      const mid = (maxLng + minLng) / 2;
      if (lng > mid) {
        hashValue = (hashValue << 1) + 1;
        minLng = mid;
      } else {
        hashValue = hashValue << 1;
        maxLng = mid;
      }
    } else {
      const mid = (maxLat + minLat) / 2;
      if (lat > mid) {
        hashValue = (hashValue << 1) + 1;
        minLat = mid;
      } else {
        hashValue = hashValue << 1;
        maxLat = mid;
      }
    }
    bits++;
    bitsTotal++;
    if (bits === 5) {
      hash += base32[hashValue];
      bits = 0;
      hashValue = 0;
    }
  }
  return hash;
}
function decodeGeohash(hash) {
  const base32 = "0123456789bcdefghjkmnpqrstuvwxyz";
  let minLat = -90;
  let maxLat = 90;
  let minLng = -180;
  let maxLng = 180;
  let isLng = true;
  for (const char of hash) {
    const value = base32.indexOf(char);
    for (let mask = 16; mask > 0; mask >>= 1) {
      if (isLng) {
        const mid = (minLng + maxLng) / 2;
        if (value & mask) {
          minLng = mid;
        } else {
          maxLng = mid;
        }
      } else {
        const mid = (minLat + maxLat) / 2;
        if (value & mask) {
          minLat = mid;
        } else {
          maxLat = mid;
        }
      }
      isLng = !isLng;
    }
  }
  return { minLat, maxLat, minLng, maxLng };
}
function getBoundingBox(center, radius) {
  const latOffset = radius / 111320;
  const lngOffset = radius / (111320 * Math.cos(center.lat * Math.PI / 180));
  return {
    minLat: center.lat - latOffset,
    maxLat: center.lat + latOffset,
    minLng: center.lng - lngOffset,
    maxLng: center.lng + lngOffset
  };
}

export {
  calculateDistance,
  formatDistance,
  calculateRouteDistance,
  geohash,
  decodeGeohash,
  getBoundingBox
};
